import workerString from "./encode-audio-worker.js?raw";

function chunkFloat32Array(float32Array, chunkLength) {
  const chunkedBuffers = [];
  for (let i = 0; i < float32Array.length; i += chunkLength) {
    const chunk = float32Array.slice(i, i + chunkLength);
    chunkedBuffers.push([chunk]);
  }
  return chunkedBuffers;
}

function concatUint8Arrays(a, b) {
  let c = new Uint8Array(a.length + b.length);
  c.set(a);
  c.set(b, a.length);
  return c;
}

async function decodeBlobToChannelData(blob) {
  const arrayBuffer = await blob.arrayBuffer();
  const audioContext = new AudioContext();
  const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
  return audioBuffer.getChannelData(0); // Mono: channel 0
}

export async function encodeOgg(blob, callback) {
  const float32Data = await decodeBlobToChannelData(blob);

  const blobURL = URL.createObjectURL(
    new Blob([workerString], { type: "text/javascript" })
  );

  const encoderWorker = new Worker(blobURL);

  let completeOggData = new Uint8Array(0);
  let bufferLength = 4096;

  encoderWorker.postMessage({
    command: "init",
    encoderSampleRate: 48000,
    bufferLength: bufferLength,
    originalSampleRate: 44100,
    encoderApplication: 2049,
    encoderComplexity: 9,
    resampleQuality: 3,
    numberOfChannels: 1,
  });

  encoderWorker.postMessage({
    command: "getHeaderPages",
  });

  chunkFloat32Array(float32Data, bufferLength).forEach((bufferChunk) =>
    encoderWorker.postMessage({
      command: "encode",
      buffers: bufferChunk,
    }),
  );

  encoderWorker.postMessage({
    command: "done",
  });

  encoderWorker.onmessage = async ({ data }) => {
    if (data.message === "done") {
      let fileName = new Date().toISOString() + ".ogg";
      let dataBlob = new Blob([completeOggData], { type: "audio/ogg" });
      callback(dataBlob, fileName);
    } else if (data.message === "page") {
      completeOggData = concatUint8Arrays(completeOggData, data.page);
    }
  };
}